import type { TypeOrArray } from '../../../../common-interfaces';
import type { JsonDataItem } from '../../../../generic-types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type { ITargetValueConverter, ValueConverterReturnType } from './i-target-value-converter';

export class DateTargetValueConverter implements ITargetValueConverter {
  convert(condition: VisibilityCondition, data: JsonDataItem): TypeOrArray<ValueConverterReturnType> {
    let dataItem;

    const targetDate = new Date();
    const targetValueItem = this.dateWithoutTime(targetDate);

    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const date = new Date(data[condition.sourceFieldId] as string);
      dataItem = this.dateWithoutTime(date);
    }

    return [dataItem, targetValueItem, condition.negation || false, condition.filterOperator || 'EQUALS'];
  }

  private dateWithoutTime(date: Date) {
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
